import styled from 'styled-components';

export const StorageUsageCard = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StorageUsageRow = styled.div`
  display: flex;
  flex-direction: row;
  &:not(:first-child) {
    margin-top: 24px;
  }
`;

export const StorageUsageType = styled.div`
  width: 72px;
  font-weight: 600;
  vertical-align: top;
  line-height: 18px;
  min-width: 80px;
`;

export const StorageUsageValue = styled.div`
  width: 17%;
  min-width: 135px;
  white-space: nowrap;
  vertical-align: top;
  line-height: 18px;
`;

export const UsedValue = styled.span<{over: boolean}>`
  color: ${props => (props.over ? '#ff5447' : '#000000')};
  font-weight: ${props => (props.over ? 'bold' : 'normal')};
`;

export const StorageUsageBar = styled.div`
  width: 70%;
  vertical-align: top;
`;
